<template>
  <div>
    <el-cascader size="small" style="width: 100%;" v-model="data" placeholder="请选择区域" :options="nodeList" clearable
      :props="{value:'areaId',label:'areaName',children:'childList'}" @change="onchange">
    </el-cascader>
  </div>
</template>

<script>
  export default {
    props: {
      value: {
        type: Array,
        default: []
      }
    },
    data() {
      return {
        nodeList: [],
        data:[]
      }
    },
    created() {
      this.data = this.value
      this.getArea();
    },
    methods: {
      getArea() {
        this.Api.express.address().then(res => {
          if (res.code == 0) {
            this.nodeList = res.data;
          }
        })
      },
      onchange(e) {
        this.$emit("change", e)
      }
    },
  }
</script>

<style>
  .el-cascader-menu__wrap {
    height: 300px;
  }
</style>



// WEBPACK FOOTER //
// src/components/public/AreaList.vue